import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Globe, CheckCircle2, ArrowRight } from 'lucide-react';
const services = [{
  id: 'mobile',
  title: 'Mobile App Development',
  description: 'Native and cross-platform mobile applications that provide seamless user experiences and robust performance.',
  icon: Smartphone,
  features: ['iOS & Android Development', 'React Native & Flutter', 'UI/UX Design', 'App Store Optimization'],
  gradient: 'from-orange-500 to-pink-500'
}, {
  id: 'wordpress',
  title: 'WordPress Development',
  description: 'Custom WordPress themes and plugins built for speed, security, and scalability to help your business grow.',
  icon: Globe,
  features: ['Custom Theme Development', 'E-commerce Solutions', 'Performance Optimization', 'Headless WordPress'],
  gradient: 'from-blue-500 to-purple-500'
}];
export function Services() {
  return <section id="services" className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-109">
      {/* Decorative background blobs */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#FFE5D9] rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-110" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#FF6B35] rounded-full blur-3xl opacity-10 translate-y-1/2 -translate-x-1/2" data-id="element-111" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-112">
        <div className="text-center mb-16" data-id="element-113">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-extrabold text-[#1a1a2e] mb-4" data-id="element-114">
            What We Create
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-115">
            We blend creativity with technical expertise to deliver digital
            products that stand out.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-116">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className="glass-card rounded-3xl p-8 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-300 bg-white/60 border-white/50" data-id="element-117">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${index === 0 ? 'from-[#FF6B35] to-[#F7931E]' : 'from-[#1a1a2e] to-[#4a4a6a]'} flex items-center justify-center mb-8 shadow-lg text-white`} data-id="element-118">
                <service.icon size={32} data-id="element-119" />
              </div>

              <h3 className="text-3xl font-bold text-[#1a1a2e] mb-4" data-id="element-120">
                {service.title}
              </h3>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-121">
                {service.description}
              </p>

              <ul className="space-y-4 mb-8" data-id="element-122">
                {service.features.map(feature => <li key={feature} className="flex items-center text-gray-700 font-medium" data-id="element-123">
                    <CheckCircle2 className="text-[#FF6B35] mr-3 flex-shrink-0" size={20} data-id="element-124" />
                    {feature}
                  </li>)}
              </ul>

              <a href="#contact" className="inline-flex items-center font-bold text-[#FF6B35] hover:text-[#F7931E] transition-colors group" data-id="element-125">
                Learn more
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} data-id="element-126" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}